define('plugin/client-login/model/ClientRemindModel',['require','lib/model/BaseModel','lib/validator/ValidatorEmail','lib/validator/ValidatorNotEmpty'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var ValidatorEmail = require('lib/validator/ValidatorEmail');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');

    /**
     * Client remind password model
     *
     * @class ClientRemindModel
     */
    return BaseModel.extend({

        url: '/ext/client/remind-password/',

        defaults: {
            email: ''
        },

        initialize: function () {
            this.validators = {
                'email': [new ValidatorNotEmpty(), new ValidatorEmail()]
            };

            BaseModel.prototype.initialize.call(this);
        }

    });

});
